import React from 'react';

import { Link } from 'gatsby';

import '../../styles/essays/index-footer.scss';

const alphaKeys = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

const getCategoryGroups = (indexItems) => {
    let groupedCategories = {};
    alphaKeys.forEach(key => groupedCategories[key] = []);
    
    indexItems.forEach(item => {
        const firstLetter = item.categoryLabel[0].toUpperCase();
        
        groupedCategories[firstLetter].push(item);
    });
    
    return groupedCategories;
};

const IndexFooter = ({ indexItems }) => {
    const groupedCategories = getCategoryGroups(indexItems);
    
    return (
        <div className="index-footer-block">
            {alphaKeys.map(key => (
                <>
                    {(groupedCategories[key].length > 0) && (
                        <>
                            <p className="letter-group-header">
                                {key}
                            </p>
                            
                            <ul className="index-listings">
                                {groupedCategories[key].map(item => (
                                    <li className="index-note">
                                        <Link
                                            to={`/explore/indexed#${item.categorySlug}`}
                                            className="category-label"
                                        >
                                            {item.categoryLabel}
                                        </Link>
                                        <Link
                                            to={`/explore/indexed#${item.categorySlug}-${item.listingSlug}`}
                                            className="listing-label"
                                        >
                                            {item.listingLabel}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </>
            ))}
        </div>
    );
};

export default IndexFooter;